import styled from 'styled-components';
import { themeOptions } from 'styles';

export const StyledBoardCompleteModal = styled.div`
  /* checkbox signup style */
  .checkbox {
    display: flex;
    align-items: flex-start;

    .MuiSvgIcon-root {
      color: ${themeOptions.palette.green.main};
    }
    .Mui-checked {
      color: ${themeOptions.palette.green.main};
    }
    .MuiCheckbox-root {
      padding: 0 7px 0 0;
    }
  }

  .modalBody {
    padding: 28px 36px;
    .flex {
      display: flex;
      justify-content: space-around;

      > div > div {
        margin: 16px 0;
      }
    }

    .modalGroup {
      margin-top: 17px;
      text-align: left;

      p {
        b {
          color: ${themeOptions.palette.green.main};
        }
      }
    }
  }

  .buttonWrap {
    display: flex;
    justify-content: end;
    margin-right: 28px;
    margin-bottom: 28px;

    button {
      display: block;
      margin-left: 8px;
    }
  }

  div.passwdCheck {
    position: relative;
    p {
      position: absolute;

      display: inline-block;
      font-size: 12px;
      color: ${themeOptions.palette.error.main};
    }
  }
`;

export const StyledBoardDetailModal = styled.div`
  .modalButtons {
    margin-top: 100px;
    margin-bottom: 30px;

    &.isAbsoluteToBottom {
      position: absolute;
      bottom: 28px;
      right: 28px;
    }
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;

  > button {
    width: 100px !important;
  }
`;
